import { render, staticRenderFns } from "./ReferralGift.vue?vue&type=template&id=1bd0d0c6&scoped=true&"
import script from "./ReferralGift.vue?vue&type=script&lang=js&"
export * from "./ReferralGift.vue?vue&type=script&lang=js&"
import style0 from "./ReferralGift.vue?vue&type=style&index=0&id=1bd0d0c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd0d0c6",
  null
  
)

export default component.exports